/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";

const $nsid = "app.bsky.notification.defs";

export { $nsid };

type Preference = { $type?: "app.bsky.notification.defs#preference";"list":boolean;"push":boolean };

export type { Preference };

const preference = /*#__PURE__*/ l.typedObject<Preference>($nsid, "preference", /*#__PURE__*/ l.object({"list":/*#__PURE__*/ l.boolean(),"push":/*#__PURE__*/ l.boolean()}));

export { preference };

type Preferences = { $type?: "app.bsky.notification.defs#preferences";

  /**
   * @deprecated use chat.bsky.notification preferences instead. This will only return a default value.
   */
  "chat":ChatPreference;"like":FilterablePreference;"quote":FilterablePreference;"reply":FilterablePreference;"follow":FilterablePreference;"repost":FilterablePreference;"mention":FilterablePreference;"verified":Preference;"unverified":Preference;"likeViaRepost":FilterablePreference;"subscribedPost":Preference;"repostViaRepost":FilterablePreference;"starterpackJoined":Preference };

export type { Preferences };

const preferences = /*#__PURE__*/ l.typedObject<Preferences>($nsid, "preferences", /*#__PURE__*/ l.object({"chat":/*#__PURE__*/ l.ref<ChatPreference>((() => chatPreference) as any),"like":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"quote":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"reply":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"follow":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"repost":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"mention":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"verified":/*#__PURE__*/ l.ref<Preference>((() => preference) as any),"unverified":/*#__PURE__*/ l.ref<Preference>((() => preference) as any),"likeViaRepost":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"subscribedPost":/*#__PURE__*/ l.ref<Preference>((() => preference) as any),"repostViaRepost":/*#__PURE__*/ l.ref<FilterablePreference>((() => filterablePreference) as any),"starterpackJoined":/*#__PURE__*/ l.ref<Preference>((() => preference) as any)}));

export { preferences };

type RecordDeleted = { $type?: "app.bsky.notification.defs#recordDeleted" };

export type { RecordDeleted };

const recordDeleted = /*#__PURE__*/ l.typedObject<RecordDeleted>($nsid, "recordDeleted", /*#__PURE__*/ l.object({}));

export { recordDeleted };

/** @deprecated use chat.bsky.notification preferences instead. This will only return a default value. */
type ChatPreference = { $type?: "app.bsky.notification.defs#chatPreference";"push":boolean;"include":"all" | "accepted" | l.UnknownString };

export type { ChatPreference };

/** @deprecated use chat.bsky.notification preferences instead. This will only return a default value. */
const chatPreference = /*#__PURE__*/ l.typedObject<ChatPreference>($nsid, "chatPreference", /*#__PURE__*/ l.object({"push":/*#__PURE__*/ l.boolean(),"include":/*#__PURE__*/ l.string<{"knownValues":["all","accepted"]}>()}));

export { chatPreference };

type ActivitySubscription = { $type?: "app.bsky.notification.defs#activitySubscription";"post":boolean;"reply":boolean };

export type { ActivitySubscription };

const activitySubscription = /*#__PURE__*/ l.typedObject<ActivitySubscription>($nsid, "activitySubscription", /*#__PURE__*/ l.object({"post":/*#__PURE__*/ l.boolean(),"reply":/*#__PURE__*/ l.boolean()}));

export { activitySubscription };

type FilterablePreference = { $type?: "app.bsky.notification.defs#filterablePreference";"list":boolean;"push":boolean;"include":"all" | "follows" | l.UnknownString };

export type { FilterablePreference };

const filterablePreference = /*#__PURE__*/ l.typedObject<FilterablePreference>($nsid, "filterablePreference", /*#__PURE__*/ l.object({"list":/*#__PURE__*/ l.boolean(),"push":/*#__PURE__*/ l.boolean(),"include":/*#__PURE__*/ l.string<{"knownValues":["all","follows"]}>()}));

export { filterablePreference };

/** Object used to store activity subscription data in stash. */
type SubjectActivitySubscription = { $type?: "app.bsky.notification.defs#subjectActivitySubscription";"subject":l.DidString;"activitySubscription":ActivitySubscription };

export type { SubjectActivitySubscription };

/** Object used to store activity subscription data in stash. */
const subjectActivitySubscription = /*#__PURE__*/ l.typedObject<SubjectActivitySubscription>($nsid, "subjectActivitySubscription", /*#__PURE__*/ l.object({"subject":/*#__PURE__*/ l.string({"format":"did"}),"activitySubscription":/*#__PURE__*/ l.ref<ActivitySubscription>((() => activitySubscription) as any)}));

export { subjectActivitySubscription };
